export const IndicatorTestIdFactory = {
    getIndicatorBase: () => 'indicator',
    getIndicatorTestId: (testId) => [IndicatorTestIdFactory.getIndicatorBase(), testId].join('-'),
};
